<template>
    <v-main>
        <Header></Header>
        <vue-pdf-app pdf="/politicas.pdf" @open="openHandler"></vue-pdf-app>
        <Footer></Footer>
    </v-main>
</template>
<script>
import Header from '@/components/header/AppBar.vue'
import Footer from '@/components/footer/FooterBar.vue'
import "vue-pdf-app/dist/icons/main.css";

export default {
    name: 'EcomerceView',
    components: {
        Header,
        Footer
    }, methods: {

        openHandler(pdfApp) {
            window._pdfApp = pdfApp;
        },
    }

}
</script>
